import { createApp } from "vue";
import App from "./App.vue";
// @ts-ignore
import router from "./router.js";
import "aos/dist/aos.css";
import "./style.css";

const app = createApp(App);
app.use(router);
app.mount("#app");
